import { makeAutoObservable } from 'mobx';
import def from './def';
import msDwnlDump from './ms_dwnl_dump'

class Data {
	s = {
		def,
		msDwnlDump
	};
	constructor(props) {
		makeAutoObservable(this);
	}
}

export default new Data();
